import { defineAsyncComponent } from 'vue'
export default {
  "404": defineAsyncComponent(() => import("/var/lib/jenkins/workspace/train73.pro/src/layouts/404.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/train73.pro/src/layouts/default.vue").then(m => m.default || m))
}